<template>
  <div class="fghotj">
    <sub-title text="热点方案推荐" />
    <ul>
      <li class="ellipsis" v-for="item in 6" :key="item">
        我于2018年3月份入职我们公司
      </li>
    </ul>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.fghotj {
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  ul {
    padding: 0 17px;
    margin-top: 20px;
    li {
      cursor: pointer;
      list-style: disc;
      list-style-position: inside;
      font-size: 14px;
      color: #666666;
      line-height: 32px;
      &:hover {
        color: #0465ea;
      }
    }
  }
}
</style>